(function () {
  'use strict';

  var busy = false;
  var addToCartBusy = false;
  var upsellRequestId = 0;

  var compareAtPriceCache = {};
  var compareAtPriceRequests = {};

  var currentCartState = null;


  /* =======================================================
     BASIC DRAWER
     ======================================================= */

  function getDrawer() {
    return document.querySelector(
      '[data-slaapgemak-cart-drawer]'
    );
  }


  function openDrawer() {
    var element = getDrawer();

    if (!element) return;

    element.classList.add('is-open');

    element.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement.classList.add(
      'slaapgemak-cart-drawer-open'
    );

    document.body.classList.add(
      'slaapgemak-cart-drawer-open'
    );
  }


  function closeDrawer() {
    var element = getDrawer();

    if (!element) return;

    element.classList.remove('is-open');

    element.setAttribute(
      'aria-hidden',
      'true'
    );

    document.documentElement.classList.remove(
      'slaapgemak-cart-drawer-open'
    );

    document.body.classList.remove(
      'slaapgemak-cart-drawer-open'
    );
  }


  function getItem(line) {
    var element = getDrawer();

    if (!element) return null;

    return element.querySelector(
      '[data-cart-item][data-line="' + line + '"]'
    );
  }


  function getQuantity(line) {
    var item = getItem(line);

    if (!item) return 1;

    var quantityElement =
      item.querySelector(
        '[data-quantity-input]'
      );

    if (!quantityElement) return 1;

    var value = parseInt(
      quantityElement.textContent.trim(),
      10
    );

    return isNaN(value) ? 1 : value;
  }


  /* =======================================================
     MONEY
     ======================================================= */

  function formatMoney(cents) {
    var value = (
      Number(cents || 0) / 100
    ).toFixed(2);

    value = value.replace('.', ',');

    return '€ ' + value;
  }


  /* =======================================================
     ESCAPING
     ======================================================= */

  function escapeHtml(value) {
    if (
      value === null ||
      value === undefined
    ) {
      return '';
    }

    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function escapeAttribute(value) {
    return escapeHtml(value);
  }


  /* =======================================================
     PRODUCT HANDLE
     ======================================================= */

  function getProductHandleFromCartItem(item) {

    if (!item) {
      return '';
    }


    if (item.handle) {
      return String(
        item.handle
      );
    }


    if (item.url) {

      var match =
        String(
          item.url
        ).match(
          /\/products\/([^?\/]+)/
        );


      if (
        match &&
        match[1]
      ) {

        return match[1];

      }

    }


    return '';
  }


  /* =======================================================
     COMPARE AT PRICE
     ======================================================= */

  function fetchProductForCartItem(
    item
  ) {

    var handle =
      getProductHandleFromCartItem(
        item
      );


    if (!handle) {

      return Promise.reject(
        new Error(
          'Geen product handle gevonden'
        )
      );

    }


    if (
      compareAtPriceCache[handle]
    ) {

      return Promise.resolve(
        compareAtPriceCache[handle]
      );

    }


    if (
      compareAtPriceRequests[handle]
    ) {

      return (
        compareAtPriceRequests[
          handle
        ]
      );

    }


    compareAtPriceRequests[handle] =
      fetch(
        window.Shopify.routes.root +
        'products/' +
        encodeURIComponent(
          handle
        ) +
        '.js',
        {
          method: 'GET',

          headers: {
            'Accept':
              'application/json'
          },

          cache:
            'no-store'
        }
      )
        .then(
          function (response) {

            if (!response.ok) {

              throw new Error(
                'Product kon niet worden opgehaald'
              );

            }


            return response.json();

          }
        )
        .then(
          function (product) {

            compareAtPriceCache[
              handle
            ] =
              product;

            return product;

          }
        )
        .finally(
          function () {

            delete compareAtPriceRequests[
              handle
            ];

          }
        );


    return (
      compareAtPriceRequests[
        handle
      ]
    );
  }


  function applyCompareAtPrice(
    item,
    wrapper,
    product
  ) {

    if (
      !item ||
      !wrapper ||
      !product ||
      !product.variants
    ) {

      return;

    }


    var variantId =
      String(
        item.variant_id || ''
      );


    if (!variantId) {
      return;
    }


    var variant =
      product.variants.find(
        function (
          productVariant
        ) {

          return (
            String(
              productVariant.id
            ) ===
            variantId
          );

        }
      );


    if (!variant) {
      return;
    }


    var compareAtPrice =
      Number(
        variant.compare_at_price || 0
      );


    var finalPrice =
      Number(
        item.final_price || 0
      );


    var originalPrice =
      Number(
        item.original_price || 0
      );


    /*
     * De echte Shopify vergelijkingsprijs
     * heeft voorrang.
     */

    var referencePrice =
      0;


    if (
      compareAtPrice >
      finalPrice
    ) {

      referencePrice =
        compareAtPrice;

    } else if (
      originalPrice >
      finalPrice
    ) {

      referencePrice =
        originalPrice;

    }


    if (
      referencePrice <=
      finalPrice
    ) {

      return;

    }


    var priceContainer =
      wrapper.querySelector(
        '.slaapgemak-cart-item__unit-price'
      );


    if (!priceContainer) {
      return;
    }


    var oldPrice =
      priceContainer.querySelector(
        '[data-line-price-old]'
      );


    if (!oldPrice) {

      oldPrice =
        document.createElement(
          'span'
        );


      oldPrice.className =
        'slaapgemak-cart-item__price-old';


      oldPrice.setAttribute(
        'data-line-price-old',
        ''
      );


      priceContainer.appendChild(
        oldPrice
      );

    }


    oldPrice.textContent =
      formatMoney(
        referencePrice
      );


    /*
     * Bewaar de vergelijkingsprijs op het
     * cart-item element zodat we later
     * het totale voordeel kunnen berekenen.
     */

    wrapper.setAttribute(
      'data-compare-at-price',
      referencePrice
    );


    wrapper.setAttribute(
      'data-final-price',
      finalPrice
    );


    wrapper.setAttribute(
      'data-cart-quantity',
      Number(
        item.quantity || 0
      )
    );


    updateDisplayedDiscountTotal();
  }


  function loadCompareAtPrice(
    item,
    wrapper
  ) {

    if (
      !item ||
      !wrapper
    ) {

      return;

    }


    fetchProductForCartItem(
      item
    )
      .then(
        function (product) {

          applyCompareAtPrice(
            item,
            wrapper,
            product
          );

        }
      )
      .catch(
        function (error) {

          console.warn(
            'Slaapgemak vergelijkingsprijs:',
            error
          );

        }
      );
  }


  /* =======================================================
     TOTAL CART DISCOUNT
     ======================================================= */

  function getTotalCartDiscount(
    cart
  ) {

    var apiDiscount =
      Number(
        cart.total_discount || 0
      );


    var calculatedDiscount =
      0;


    if (
      cart &&
      Array.isArray(
        cart.items
      )
    ) {

      cart.items.forEach(
        function (item) {

          /*
           * Shopify regelkorting indien aanwezig.
           */

          var lineDiscount =
            Number(
              item.line_level_total_discount ||
              0
            );


          if (
            !isNaN(
              lineDiscount
            ) &&
            lineDiscount > 0
          ) {

            calculatedDiscount +=
              lineDiscount;

            return;

          }


          /*
           * Fallback naar original_price
           * tegenover final_price.
           */

          var originalPrice =
            Number(
              item.original_price || 0
            );


          var finalPrice =
            Number(
              item.final_price || 0
            );


          var quantity =
            Number(
              item.quantity || 0
            );


          if (
            originalPrice >
            finalPrice
          ) {

            calculatedDiscount +=
              (
                originalPrice -
                finalPrice
              ) *
              quantity;

          }

        }
      );

    }


    return Math.max(
      apiDiscount,
      calculatedDiscount
    );
  }


  function updateDisplayedDiscountTotal() {

    var drawer =
      getDrawer();


    if (!drawer) return;


    var footer =
      drawer.querySelector(
        '.slaapgemak-cart-drawer__footer'
      );


    if (!footer) {
      return;
    }


    var discountFromCompareAt =
      0;


    var cartItems =
      drawer.querySelectorAll(
        '[data-cart-item]'
      );


    cartItems.forEach(
      function (item) {

        var compareAt =
          Number(
            item.getAttribute(
              'data-compare-at-price'
            ) || 0
          );


        var finalPrice =
          Number(
            item.getAttribute(
              'data-final-price'
            ) || 0
          );


        var quantity =
          Number(
            item.getAttribute(
              'data-cart-quantity'
            ) || 0
          );


        if (
          compareAt >
          finalPrice
        ) {

          discountFromCompareAt +=
            (
              compareAt -
              finalPrice
            ) *
            quantity;

        }

      }
    );


    var apiDiscount =
      currentCartState
        ? Number(
            currentCartState.total_discount ||
            0
          )
        : 0;


    var lineDiscount =
      0;


    if (
      currentCartState &&
      Array.isArray(
        currentCartState.items
      )
    ) {

      currentCartState.items.forEach(
        function (item) {

          var value =
            Number(
              item.line_level_total_discount ||
              0
            );


          if (
            !isNaN(value)
          ) {

            lineDiscount +=
              value;

          }

        }
      );

    }


    var totalDiscount =
      Math.max(
        apiDiscount,
        lineDiscount,
        discountFromCompareAt
      );


    var saving =
      footer.querySelector(
        '.slaapgemak-cart-drawer__saving'
      );


    if (
      totalDiscount > 0
    ) {

      if (!saving) {

        saving =
          document.createElement(
            'div'
          );


        saving.className =
          'slaapgemak-cart-drawer__saving';


        var subtotal =
          footer.querySelector(
            '.slaapgemak-cart-drawer__subtotal'
          );


        if (subtotal) {

          subtotal.insertAdjacentElement(
            'afterend',
            saving
          );

        } else {

          footer.insertBefore(
            saving,
            footer.firstChild
          );

        }

      }


      saving.innerHTML =

        '<span>' +
          'Je bespaart' +
        '</span>' +

        '<strong>' +
          formatMoney(
            totalDiscount
          ) +
        '</strong>';

    } else if (
      saving
    ) {

      saving.remove();

    }
  }


  /* =======================================================
     HEADER
     ======================================================= */

  function updateHeader(
    cart
  ) {

    var countElements =
      document.querySelectorAll(
        '[data-header-cart-count]'
      );


    countElements.forEach(
      function (element) {

        element.textContent =
          cart.item_count;


        if (
          cart.item_count > 0
        ) {

          element.classList.remove(
            'hidden'
          );

        } else {

          element.classList.add(
            'hidden'
          );

        }

      }
    );


    var totalElements =
      document.querySelectorAll(
        '[data-header-cart-total]'
      );


    totalElements.forEach(
      function (element) {

        element.textContent =
          formatMoney(
            cart.total_price
          );

      }
    );


    var headerCartLinks =
      document.querySelectorAll(
        '.header-icons-link.cart'
      );


    headerCartLinks.forEach(
      function (element) {

        if (
          cart.item_count > 0
        ) {

          element.classList.add(
            'has-items'
          );

        } else {

          element.classList.remove(
            'has-items'
          );

        }

      }
    );
  }


  /* =======================================================
     DRAWER COUNT
     ======================================================= */

  function updateDrawerCount(
    cart
  ) {

    var drawer =
      getDrawer();


    if (!drawer) return;


    var heading =
      drawer.querySelector(
        '.slaapgemak-cart-drawer__heading'
      );


    if (!heading) return;


    var count =
      heading.querySelector(
        '.slaapgemak-cart-drawer__count'
      );


    if (
      cart.item_count > 0
    ) {

      if (!count) {

        count =
          document.createElement(
            'span'
          );


        count.className =
          'slaapgemak-cart-drawer__count';


        heading.appendChild(
          count
        );

      }


      count.textContent =
        cart.item_count;

    } else if (
      count
    ) {

      count.remove();

    }
  }


  /* =======================================================
     SHIPPING
     ======================================================= */

  function getShippingSubtotal(
    cart
  ) {

    if (
      cart &&
      cart.items_subtotal_price !== undefined &&
      cart.items_subtotal_price !== null
    ) {

      var subtotal =
        Number(
          cart.items_subtotal_price
        );


      if (
        !isNaN(
          subtotal
        )
      ) {

        return subtotal;

      }

    }


    if (
      cart &&
      Array.isArray(
        cart.items
      )
    ) {

      var calculatedSubtotal =
        cart.items.reduce(
          function (
            total,
            item
          ) {

            var lineTotal =
              Number(
                item.final_line_price
              );


            if (
              isNaN(
                lineTotal
              )
            ) {

              lineTotal =
                Number(
                  item.line_price
                );

            }


            if (
              isNaN(
                lineTotal
              )
            ) {

              lineTotal =
                0;

            }


            return (
              total +
              lineTotal
            );

          },
          0
        );


      return calculatedSubtotal;

    }


    return 0;
  }


  function updateShipping(
    cart
  ) {

    var drawer =
      getDrawer();


    if (!drawer) return;


    var shipping =
      drawer.querySelector(
        '[data-sg-shipping]'
      );


    if (!shipping) return;


    var threshold =
      parseInt(
        shipping.getAttribute(
          'data-shipping-threshold'
        ),
        10
      );


    if (
      isNaN(
        threshold
      ) ||
      threshold <= 0
    ) {

      return;

    }


    var subtotal =
      getShippingSubtotal(
        cart
      );


    var percentage =
      (
        subtotal /
        threshold
      ) * 100;


    percentage =
      Math.max(
        0,
        Math.min(
          100,
          percentage
        )
      );


    var bar =
      shipping.querySelector(
        '[data-sg-shipping-bar]'
      );


    if (bar) {

      bar.style.width =
        percentage + '%';

    }


    var text =
      shipping.querySelector(
        '[data-sg-shipping-text]'
      );


    if (!text) return;


    var beforeText =
      shipping.getAttribute(
        'data-shipping-before'
      ) || '';


    var afterText =
      shipping.getAttribute(
        'data-shipping-after'
      ) || '';


    if (
      subtotal >=
      threshold
    ) {

      text.textContent =
        afterText;

      return;

    }


    var remaining =
      threshold -
      subtotal;


    text.textContent =
      beforeText.replace(
        '[amount]',
        formatMoney(
          remaining
        )
      );
  }


  /* =======================================================
     LINE PRICE
     ======================================================= */

  function updateLinePrice(
    line,
    cart
  ) {

    var item =
      getItem(
        line
      );


    if (!item) return;


    var cartItem =
      cart.items[
        line - 1
      ];


    if (!cartItem) return;


    var unitPrice =
      item.querySelector(
        '[data-line-price]'
      );


    var lineTotal =
      item.querySelector(
        '[data-line-total]'
      );


    var oldPrice =
      item.querySelector(
        '[data-line-price-old]'
      );


    if (unitPrice) {

      unitPrice.textContent =
        formatMoney(
          cartItem.final_price
        );

    }


    if (lineTotal) {

      lineTotal.textContent =
        formatMoney(
          cartItem.final_line_price
        );

    }


    if (
      cartItem.original_price >
      cartItem.final_price
    ) {

      if (!oldPrice) {

        var priceContainer =
          item.querySelector(
            '.slaapgemak-cart-item__unit-price'
          );


        if (
          priceContainer
        ) {

          oldPrice =
            document.createElement(
              'span'
            );


          oldPrice.className =
            'slaapgemak-cart-item__price-old';


          oldPrice.setAttribute(
            'data-line-price-old',
            ''
          );


          priceContainer.appendChild(
            oldPrice
          );

        }

      }


      if (oldPrice) {

        oldPrice.textContent =
          formatMoney(
            cartItem.original_price
          );

      }

    } else if (
      oldPrice
    ) {

      oldPrice.remove();

    }
  }


  /* =======================================================
     QUANTITY DISPLAY
     ======================================================= */

  function updateQuantityDisplay(
    line,
    quantity
  ) {

    var item =
      getItem(
        line
      );


    if (!item) return;


    var quantityElement =
      item.querySelector(
        '[data-quantity-input]'
      );


    if (
      quantityElement
    ) {

      quantityElement.textContent =
        quantity;

    }


    if (
      quantity <= 0
    ) {

      item.remove();

    }
  }


  /* =======================================================
     CREATE CART ITEM
     ======================================================= */

  function createCartItem(
    item,
    line
  ) {

    var wrapper =
      document.createElement(
        'div'
      );


    wrapper.className =
      'slaapgemak-cart-item';


    wrapper.setAttribute(
      'data-cart-item',
      ''
    );


    wrapper.setAttribute(
      'data-line',
      line
    );


    var imageUrl =
      item.image ||
      '';


    var imageAlt =
      item.title ||
      'Product';


    var variantHtml =
      '';


    if (
      item.variant_title &&
      item.variant_title !==
        'Default Title'
    ) {

      variantHtml =

        '<div class="slaapgemak-cart-item__variant">' +

          escapeHtml(
            item.variant_title
          ) +

        '</div>';

    }


    var oldPriceHtml =
      '';


    if (
      item.original_price >
      item.final_price
    ) {

      oldPriceHtml =

        '<span class="slaapgemak-cart-item__price-old" data-line-price-old>' +

          formatMoney(
            item.original_price
          ) +

        '</span>';

    }


    wrapper.innerHTML =

      '<a href="' +
        escapeAttribute(
          item.url ||
          '#'
        ) +
        '" class="slaapgemak-cart-item__image">' +

        '<img src="' +
          escapeAttribute(
            imageUrl
          ) +
          '" alt="' +
          escapeAttribute(
            imageAlt
          ) +
          '" loading="lazy" width="84" height="84">' +

      '</a>' +


      '<div class="slaapgemak-cart-item__content">' +


        '<div class="slaapgemak-cart-item__top">' +


          '<div class="slaapgemak-cart-item__info">' +

            '<a href="' +
              escapeAttribute(
                item.url ||
                '#'
              ) +
              '" class="slaapgemak-cart-item__title">' +

              escapeHtml(
                item.product_title ||
                item.title
              ) +

            '</a>' +

            variantHtml +

          '</div>' +


          '<button ' +
            'type="button" ' +
            'class="slaapgemak-cart-item__remove" ' +
            'data-item-remove ' +
            'data-line="' +
              line +
            '" ' +
            'aria-label="' +
              escapeAttribute(
                (
                  item.product_title ||
                  item.title
                ) +
                ' verwijderen'
              ) +
          '">' +

            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +

              '<path d="M3.5 3.5L12.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +

              '<path d="M12.5 3.5L3.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +

            '</svg>' +

          '</button>' +

        '</div>' +


        '<div class="slaapgemak-cart-item__bottom">' +


          '<div class="slaapgemak-cart-item__quantity" data-quantity-wrapper>' +

            '<button ' +
              'type="button" ' +
              'data-quantity-decrement ' +
              'data-line="' +
                line +
              '" ' +
              'aria-label="Aantal verminderen">' +

              '−' +

            '</button>' +


            '<span data-quantity-input>' +
              item.quantity +
            '</span>' +


            '<button ' +
              'type="button" ' +
              'data-quantity-increment ' +
              'data-line="' +
                line +
              '" ' +
              'aria-label="Aantal verhogen">' +

              '+' +

            '</button>' +

          '</div>' +


          '<div class="slaapgemak-cart-item__price">' +


            '<div class="slaapgemak-cart-item__unit-price">' +


              '<span class="slaapgemak-cart-item__price-current" data-line-price>' +

                formatMoney(
                  item.final_price
                ) +

              '</span>' +


              '<span class="slaapgemak-cart-item__price-per">' +
                'per stuk' +
              '</span>' +


              oldPriceHtml +


            '</div>' +


            '<span class="slaapgemak-cart-item__line-total" data-line-total>' +

              formatMoney(
                item.final_line_price
              ) +

            '</span>' +


          '</div>' +


        '</div>' +


      '</div>';


    /*
     * Zoek de echte compare-at-prijs op
     * nadat het cart-item is opgebouwd.
     */

    loadCompareAtPrice(
      item,
      wrapper
    );


    return wrapper;
  }


  /* =======================================================
     BENEFITS
     ======================================================= */

  function createBenefits() {

    var benefits =
      document.createElement(
        'div'
      );


    benefits.className =
      'slaapgemak-cart-drawer__benefits';


    var items = [
      'Binnen 2 werkdagen in huis',
      '14 dagen bedenktijd & eenvoudig retourneren',
      'Veilig en vertrouwd afrekenen'
    ];


    items.forEach(
      function (text) {

        var benefit =
          document.createElement(
            'div'
          );


        benefit.className =
          'slaapgemak-cart-drawer__benefit';


        benefit.innerHTML =

          '<span class="slaapgemak-cart-drawer__benefit-icon">' +

            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +

              '<path d="M3 7.2L5.5 9.5L11 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +

            '</svg>' +

          '</span>' +

          '<span>' +
            escapeHtml(
              text
            ) +
          '</span>';


        benefits.appendChild(
          benefit
        );

      }
    );


    return benefits;
  }


  /* =======================================================
     UPSELL
     ======================================================= */

  function loadUpsell(
    cart
  ) {

    var drawer =
      getDrawer();


    if (!drawer) return;


    var upsell =
      drawer.querySelector(
        '[data-sg-upsell]'
      );


    if (!upsell) return;


    upsell.hidden =
      true;


    upsell.innerHTML =
      '';


    if (
      !cart.items ||
      cart.items.length === 0
    ) {

      return;

    }


    var requestId =
      ++upsellRequestId;


    var HANDLE_MEMORY_FOAM =
      'memory-foam-pillow';


    var HANDLE_TENCEL =
      'encel-pillowcase';


    var HANDLE_COOLING =
      'spandex-cooling-cover';


    var HANDLE_EXTRA_FILLING =
      'extra-filling';


    var cartProductIds =
      cart.items.map(
        function (item) {

          return String(
            item.product_id
          );

        }
      );


    var cartHandles =
      cart.items.map(
        function (item) {

          return (
            item.handle ||
            ''
          ).toLowerCase();

        }
      );


    var cartTitles =
      cart.items.map(
        function (item) {

          return (
            (
              item.product_title ||
              ''
            ) +
            ' ' +
            (
              item.title ||
              ''
            )
          ).toLowerCase();

        }
      );


    var hasMemoryFoam =
      cartHandles.indexOf(
        HANDLE_MEMORY_FOAM
      ) !== -1
      ||
      cartTitles.some(
        function (title) {

          return (
            title.indexOf(
              'memory foam'
            ) !== -1
            ||
            title.indexOf(
              'memoryfoam'
            ) !== -1
          );

        }
      );


    var hasTencel =
      cartHandles.indexOf(
        HANDLE_TENCEL
      ) !== -1
      ||
      cartTitles.some(
        function (title) {

          return (
            title.indexOf(
              'tencel'
            ) !== -1
            ||
            title.indexOf(
              'encel'
            ) !== -1
          );

        }
      );


    var hasCooling =
      cartHandles.indexOf(
        HANDLE_COOLING
      ) !== -1
      ||
      cartTitles.some(
        function (title) {

          return (
            title.indexOf(
              'cooling'
            ) !== -1
            ||
            title.indexOf(
              'spandex'
            ) !== -1
          );

        }
      );


    var hasExtraFilling =
      cartHandles.indexOf(
        HANDLE_EXTRA_FILLING
      ) !== -1
      ||
      cartTitles.some(
        function (title) {

          return (
            title.indexOf(
              'extra filling'
            ) !== -1
            ||
            title.indexOf(
              'extra vulling'
            ) !== -1
            ||
            title.indexOf(
              'extra memory foam'
            ) !== -1
          );

        }
      );


    var hasBundle =
      cart.items.some(
        function (item) {

          var title =
            (
              item.product_title ||
              item.title ||
              ''
            ).toLowerCase();


          return (
            title.indexOf(
              'bundel'
            ) !== -1
            ||
            title.indexOf(
              'bundle'
            ) !== -1
          );

        }
      );


    var targetHandles =
      [];


    if (hasBundle) {

      if (!hasExtraFilling) {

        targetHandles.push(
          HANDLE_EXTRA_FILLING
        );

      }

    } else if (
      hasMemoryFoam
    ) {

      if (!hasTencel) {

        targetHandles.push(
          HANDLE_TENCEL
        );

      }


      if (!hasCooling) {

        targetHandles.push(
          HANDLE_COOLING
        );

      }

    } else if (
      hasCooling
    ) {

      if (!hasMemoryFoam) {

        targetHandles.push(
          HANDLE_MEMORY_FOAM
        );

      }


      if (!hasTencel) {

        targetHandles.push(
          HANDLE_TENCEL
        );

      }

    } else if (
      hasTencel
    ) {

      if (!hasMemoryFoam) {

        targetHandles.push(
          HANDLE_MEMORY_FOAM
        );

      }


      if (!hasCooling) {

        targetHandles.push(
          HANDLE_COOLING
        );

      }

    } else {

      if (!hasMemoryFoam) {

        targetHandles.push(
          HANDLE_MEMORY_FOAM
        );

      }


      if (!hasTencel) {

        targetHandles.push(
          HANDLE_TENCEL
        );

      }

    }


    targetHandles =
      targetHandles.filter(
        function (
          handle,
          index,
          array
        ) {

          return (
            array.indexOf(
              handle
            ) === index
          );

        }
      );


    if (hasBundle) {

      targetHandles =
        targetHandles.slice(
          0,
          1
        );

    } else {

      targetHandles =
        targetHandles.slice(
          0,
          2
        );

    }


    if (
      targetHandles.length === 0
    ) {

      return;

    }


    function fetchProductByHandle(
      handle
    ) {

      return fetch(
        window.Shopify.routes.root +
        'products/' +
        encodeURIComponent(
          handle
        ) +
        '.js',
        {
          method: 'GET',

          headers: {
            'Accept':
              'application/json'
          }
        }
      )
        .then(
          function (response) {

            if (!response.ok) {

              throw new Error(
                'Product niet gevonden'
              );

            }


            return response.json();

          }
        );

    }


    function searchTencelFallback() {

      var url =
        window.Shopify.routes.root +
        'search/suggest.json' +
        '?q=' +
        encodeURIComponent(
          'Tencel Kussensloop'
        ) +
        '&resources[type]=product' +
        '&resources[limit]=10' +
        '&resources[options][unavailable_products]=hide';


      return fetch(
        url,
        {
          method: 'GET',

          headers: {
            'Accept':
              'application/json'
          }
        }
      )
        .then(
          function (response) {

            if (!response.ok) {

              throw new Error(
                'Tencel zoeken mislukt'
              );

            }


            return response.json();

          }
        )
        .then(
          function (data) {

            if (
              !data ||
              !data.resources ||
              !data.resources.results
            ) {

              return null;

            }


            var products =
              data.resources.results.products ||
              [];


            var product =
              products.find(
                function (item) {

                  return (
                    item &&
                    cartProductIds.indexOf(
                      String(item.id)
                    ) === -1
                  );

                }
              );


            if (!product) {
              return null;
            }


            return fetchProductByHandle(
              product.handle
            );

          }
        );

    }


    function loadSingleProduct(
      handle
    ) {

      return fetchProductByHandle(
        handle
      )
        .catch(
          function () {

            if (
              handle ===
              HANDLE_TENCEL
            ) {

              return searchTencelFallback();

            }


            throw new Error(
              'Upsell product kon niet worden geladen'
            );

          }
        );

    }


    Promise.all(
      targetHandles.map(
        function (handle) {

          return loadSingleProduct(
            handle
          )
            .catch(
              function () {

                return null;

              }
            );

        }
      )
    )
      .then(
        function (products) {

          if (
            requestId !==
            upsellRequestId
          ) {

            return;

          }


          var validProducts =
            products.filter(
              function (product) {

                if (!product) {
                  return false;
                }


                if (
                  cartProductIds.indexOf(
                    String(
                      product.id
                    )
                  ) !== -1
                ) {

                  return false;

                }


                return (
                  product.variants &&
                  product.variants.some(
                    function (variant) {

                      return (
                        variant &&
                        variant.available !== false
                      );

                    }
                  )
                );

              }
            );


          if (
            validProducts.length === 0
          ) {

            return;

          }


          validProducts =
            validProducts.slice(
              0,
              hasBundle
                ? 1
                : 2
            );


          validProducts.forEach(
            function (product) {

              var variant =
                (
                  product.variants ||
                  []
                ).find(
                  function (item) {

                    return (
                      item &&
                      item.available !== false
                    );

                  }
                );


              product.selected_variant =
                variant;

            }
          );


          renderUpsells(
            validProducts
          );

        }
      )
      .catch(
        function (error) {

          console.error(
            'Slaapgemak upsell:',
            error
          );

        }
      );
  }


  /* =======================================================
     RENDER UPSELLS
     ======================================================= */

  function renderUpsells(
    products
  ) {

    var drawer =
      getDrawer();


    if (!drawer) return;


    var upsell =
      drawer.querySelector(
        '[data-sg-upsell]'
      );


    if (!upsell) return;


    if (
      !products ||
      products.length === 0
    ) {

      return;

    }


    var productsHtml =
      '';


    products.forEach(
      function (product) {

        var variant =
          product.selected_variant ||
          (
            product.variants &&
            product.variants.find(
              function (item) {

                return (
                  item &&
                  item.available !== false
                );

              }
            )
          );


        if (!variant) {
          return;
        }


        var image =
          product.featured_image ||
          (
            product.images &&
            product.images[0]
          ) ||
          '';


        var priceHtml =
          '<span>' +
            formatMoney(
              variant.price
            ) +
          '</span>';


        var comparePrice =
          variant.compare_at_price &&
          Number(
            variant.compare_at_price
          ) >
          Number(
            variant.price
          )
            ? variant.compare_at_price
            : null;


        if (
          comparePrice
        ) {

          priceHtml +=

            '<span class="slaapgemak-cart-drawer__upsell-old-price">' +

              formatMoney(
                comparePrice
              ) +

            '</span>';

        }


        productsHtml +=

          '<div class="slaapgemak-cart-drawer__upsell-item">' +

            (
              image

                ? '<a href="' +
                    escapeAttribute(
                      product.url ||
                      (
                        '/products/' +
                        product.handle
                      )
                    ) +
                    '" class="slaapgemak-cart-drawer__upsell-image">' +

                    '<img src="' +
                      escapeAttribute(
                        image
                      ) +
                      '" alt="' +
                      escapeAttribute(
                        product.title
                      ) +
                      '" loading="lazy" width="58" height="58">' +

                  '</a>'

                : ''
            ) +


            '<div class="slaapgemak-cart-drawer__upsell-info">' +

              '<a href="' +
                escapeAttribute(
                  product.url ||
                  (
                    '/products/' +
                    product.handle
                  )
                ) +
                '" class="slaapgemak-cart-drawer__upsell-title">' +

                escapeHtml(
                  product.title
                ) +

              '</a>' +


              '<div class="slaapgemak-cart-drawer__upsell-price">' +
                priceHtml +
              '</div>' +

            '</div>' +


            '<button ' +
              'type="button" ' +
              'class="slaapgemak-cart-drawer__upsell-add" ' +
              'data-sg-upsell-add ' +
              'data-variant-id="' +
                variant.id +
              '">' +

              'Toevoegen' +

            '</button>' +

          '</div>';

      }
    );


    if (!productsHtml) {
      return;
    }


    upsell.innerHTML =

      '<div class="slaapgemak-cart-drawer__upsell-top">' +

        '<span class="slaapgemak-cart-drawer__upsell-label">' +
          'Slimme keuze' +
        '</span>' +

        '<span class="slaapgemak-cart-drawer__upsell-heading">' +
          'Maak je slaap compleet' +
        '</span>' +

      '</div>' +


      '<div class="slaapgemak-cart-drawer__upsell-list">' +
        productsHtml +
      '</div>';


    upsell.hidden =
      false;
  }


  /* =======================================================
     ADD UPSELL PRODUCT
     ======================================================= */

  function addUpsellProduct(
    button
  ) {

    if (!button) return;


    if (
      button.classList.contains(
        'is-loading'
      )
    ) {

      return;

    }


    var variantId =
      button.getAttribute(
        'data-variant-id'
      );


    if (!variantId) return;


    button.classList.add(
      'is-loading'
    );


    button.disabled =
      true;


    fetch(
      window.Shopify.routes.root +
      'cart/add.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          'Accept':
            'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id: Number(
                variantId
              ),
              quantity: 1
            }
          ]
        })
      }
    )
      .then(
        function (response) {

          if (!response.ok) {

            return response.json()
              .then(
                function (data) {

                  throw new Error(
                    data.description ||
                    data.message ||
                    'Product toevoegen mislukt'
                  );

                }
              );

          }


          return response.json();

        }
      )
      .then(
        function () {

          return fetch(
            window.Shopify.routes.root +
            'cart.js',
            {
              method: 'GET',

              headers: {
                'Accept':
                  'application/json'
              }
            }
          );

        }
      )
      .then(
        function (response) {

          if (!response.ok) {

            throw new Error(
              'Winkelwagen ophalen mislukt'
            );

          }


          return response.json();

        }
      )
      .then(
        function (cart) {

          rebuildDrawer(
            cart
          );


          updateHeader(
            cart
          );


          updateShipping(
            cart
          );


          document.dispatchEvent(
            new CustomEvent(
              'slaapgemak:cart-updated',
              {
                detail: {
                  cart: cart
                }
              }
            )
          );

        }
      )
      .catch(
        function (error) {

          console.error(
            'Slaapgemak upsell:',
            error
          );


          button.classList.remove(
            'is-loading'
          );


          button.disabled =
            false;

        }
      );
  }


  /* =======================================================
     FOOTER
     ======================================================= */

  function createOrUpdateFooter(
    cart
  ) {

    var drawer =
      getDrawer();


    if (!drawer) return;


    var panel =
      drawer.querySelector(
        '.slaapgemak-cart-drawer__panel'
      );


    if (!panel) return;


    var footer =
      panel.querySelector(
        '.slaapgemak-cart-drawer__footer'
      );


    if (!footer) {

      footer =
        document.createElement(
          'div'
        );


      footer.className =
        'slaapgemak-cart-drawer__footer';


      panel.appendChild(
        footer
      );

    }


    var totalDiscount =
      getTotalCartDiscount(
        cart
      );


    footer.innerHTML =

      '<div class="slaapgemak-cart-drawer__subtotal">' +

        '<span>' +
          'Subtotaal' +
        '</span>' +

        '<strong>' +
          formatMoney(
            cart.items_subtotal_price
          ) +
        '</strong>' +

      '</div>' +


      (
        totalDiscount > 0

          ? '<div class="slaapgemak-cart-drawer__saving">' +

              '<span>' +
                'Je bespaart' +
              '</span>' +

              '<strong>' +
                formatMoney(
                  totalDiscount
                ) +
              '</strong>' +

            '</div>'

          : ''
      ) +


      '<a href="' +
        window.Shopify.routes.root +
        'checkout" ' +
        'class="slaapgemak-cart-drawer__checkout">' +

        '<span>' +
          'Afrekenen' +
        '</span>' +

        '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">' +

          '<path d="M3.5 9H14.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +

          '<path d="M10 4.5L14.5 9L10 13.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +

        '</svg>' +

      '</a>' +


      '<button type="button" class="slaapgemak-cart-drawer__continue" data-slaapgemak-cart-close>' +

        'Verder winkelen' +

      '</button>' +


      '<div class="slaapgemak-cart-drawer__secure">' +

        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +

          '<rect x="3" y="6" width="8" height="6" rx="1" stroke="currentColor" stroke-width="1.2"/>' +

          '<path d="M4.5 6V4.5C4.5 2.84315 5.84315 1.5 7.5 1.5C9.15685 1.5 10.5 2.84315 10.5 4.5V6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +

        '</svg>' +

        '<span>' +
          'Veilig afrekenen' +
        '</span>' +

      '</div>';
  }


  /* =======================================================
     EMPTY STATE
     ======================================================= */

  function showEmptyState() {

    var element =
      getDrawer();


    if (!element) return;


    var body =
      element.querySelector(
        '[data-slaapgemak-cart-body]'
      );


    if (!body) return;


    body.innerHTML =

      '<div class="slaapgemak-cart-drawer__empty">' +

        '<div class="slaapgemak-cart-drawer__empty-icon">' +

          '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true">' +

            '<path d="M20.4167 9.58333V7.91667C20.4167 5.15524 18.1781 2.91667 15.4167 2.91667H14.5833C11.8219 2.91667 9.58333 5.15524 9.58333 7.91667V9.58333" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +

            '<path d="M4.58333 9.58333H25.4167L24.1667 24.1667C24.0539 25.4844 22.9495 26.5 21.627 26.5H8.37302C7.0505 26.5 5.94608 25.4844 5.83333 24.1667L4.58333 9.58333Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +

          '</svg>' +

        '</div>' +


        '<h3>' +
          'Je winkelwagen is leeg' +
        '</h3>' +


        '<p>' +
          'Ontdek onze producten en maak van je nachtrust een moment van echt gemak.' +
        '</p>' +


        '<a href="/collections/all" class="slaapgemak-cart-drawer__empty-button">' +
          'Bekijk onze producten' +
        '</a>' +

      '</div>';


    var footer =
      element.querySelector(
        '.slaapgemak-cart-drawer__footer'
      );


    if (footer) {
      footer.remove();
    }
  }


  /* =======================================================
     REBUILD DRAWER
     ======================================================= */

  function rebuildDrawer(
    cart
  ) {

    var drawer =
      getDrawer();


    if (!drawer) return;


    var body =
      drawer.querySelector(
        '[data-slaapgemak-cart-body]'
      );


    if (!body) return;


    currentCartState =
      cart;


    upsellRequestId++;


    /*
     * Bewaar de bestaande shipping bar.
     */

    var existingShipping =
      drawer.querySelector(
        '[data-sg-shipping]'
      );


    var shippingIsInsideBody =
      existingShipping &&
      body.contains(
        existingShipping
      );


    if (
      shippingIsInsideBody
    ) {

      body.removeChild(
        existingShipping
      );

    }


    body.innerHTML =
      '';


    if (
      !cart.items ||
      cart.items.length === 0
    ) {

      showEmptyState();


      updateDrawerCount(
        cart
      );


      updateHeader(
        cart
      );


      return;

    }


    /*
     * Shipping bar terugplaatsen.
     */

    if (
      shippingIsInsideBody
    ) {

      body.appendChild(
        existingShipping
      );


      updateShipping(
        cart
      );

    } else {

      var shipping =
        createShippingElement(
          cart
        );


      if (shipping) {

        updateShipping(
          cart
        );

      }

    }


    var items =
      document.createElement(
        'div'
      );


    items.className =
      'slaapgemak-cart-drawer__items';


    cart.items.forEach(
      function (
        item,
        index
      ) {

        items.appendChild(
          createCartItem(
            item,
            index + 1
          )
        );

      }
    );


    body.appendChild(
      items
    );


    var upsell =
      document.createElement(
        'div'
      );


    upsell.className =
      'slaapgemak-cart-drawer__upsell';


    upsell.setAttribute(
      'data-sg-upsell',
      ''
    );


    upsell.hidden =
      true;


    body.appendChild(
      upsell
    );


    body.appendChild(
      createBenefits()
    );


    createOrUpdateFooter(
      cart
    );


    updateDrawerCount(
      cart
    );


    updateHeader(
      cart
    );


    updateShipping(
      cart
    );


    updateDisplayedDiscountTotal();


    loadUpsell(
      cart
    );
  }


  /* =======================================================
     UPDATE CART
     ======================================================= */

  function updateCart(
    line,
    quantity
  ) {

    if (busy) return;


    busy = true;


    var item =
      getItem(
        line
      );


    if (item) {

      item.classList.add(
        'is-loading'
      );

    }


    fetch(
      window.Shopify.routes.root +
      'cart/change.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          'Accept':
            'application/json'
        },

        body: JSON.stringify({
          line:
            line,
          quantity:
            quantity
        })
      }
    )
      .then(
        function (response) {

          if (!response.ok) {

            throw new Error(
              'Cart update failed'
            );

          }


          return response.json();

        }
      )
      .then(
        function (cart) {

          rebuildDrawer(
            cart
          );


          updateShipping(
            cart
          );


          document.dispatchEvent(
            new CustomEvent(
              'slaapgemak:cart-updated',
              {
                detail: {
                  cart:
                    cart
                }
              }
            )
          );

        }
      )
      .catch(
        function (error) {

          console.error(
            'Slaapgemak winkelwagen:',
            error
          );

        }
      )
      .finally(
        function () {

          if (item) {

            item.classList.remove(
              'is-loading'
            );

          }


          busy =
            false;

        }
      );
  }


  /* =======================================================
     SHIPPING ELEMENT
     ======================================================= */

  function createShippingElement(
    cart
  ) {

    var drawer =
      getDrawer();


    if (!drawer) return null;


    var existing =
      drawer.querySelector(
        '[data-sg-shipping]'
      );


    if (existing) {

      return existing;

    }


    var enabled =
      drawer.getAttribute(
        'data-sg-shipping-enabled'
      );


    if (
      enabled ===
      'false'
    ) {

      return null;

    }


    var threshold =
      parseInt(
        drawer.getAttribute(
          'data-sg-shipping-threshold'
        ),
        10
      );


    if (
      isNaN(
        threshold
      ) ||
      threshold <= 0
    ) {

      return null;

    }


    var beforeText =
      drawer.getAttribute(
        'data-sg-shipping-before'
      ) ||
      'Nog [amount] tot gratis verzending';


    var afterText =
      drawer.getAttribute(
        'data-sg-shipping-after'
      ) ||
      'Je hebt gratis verzending!';


    var shipping =
      document.createElement(
        'div'
      );


    shipping.className =
      'slaapgemak-cart-drawer__shipping';


    shipping.setAttribute(
      'data-sg-shipping',
      ''
    );


    shipping.setAttribute(
      'data-shipping-threshold',
      threshold
    );


    shipping.setAttribute(
      'data-shipping-before',
      beforeText
    );


    shipping.setAttribute(
      'data-shipping-after',
      afterText
    );


    shipping.innerHTML =

      '<div class="slaapgemak-cart-drawer__shipping-header">' +

        '<div class="slaapgemak-cart-drawer__shipping-icon">' +

          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +

            '<path d="M1.5 4.5H10V11H1.5V4.5Z" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"/>' +

            '<path d="M10 6H12.1L14.5 8.5V11H10V6Z" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"/>' +

            '<circle cx="4" cy="11.5" r="1.25" stroke="currentColor" stroke-width="1.25"/>' +

            '<circle cx="12" cy="11.5" r="1.25" stroke="currentColor" stroke-width="1.25"/>' +

          '</svg>' +

        '</div>' +

        '<p class="slaapgemak-cart-drawer__shipping-text" data-sg-shipping-text></p>' +

      '</div>' +


      '<div class="slaapgemak-cart-drawer__shipping-progress">' +

        '<div class="slaapgemak-cart-drawer__shipping-progress-bar" data-sg-shipping-bar></div>' +

      '</div>';


    var body =
      drawer.querySelector(
        '[data-slaapgemak-cart-body]'
      );


    if (body) {

      body.insertBefore(
        shipping,
        body.firstChild
      );

    }


    return shipping;
  }


  /* =======================================================
     ADD PRODUCT FROM FORM
     ======================================================= */

  function addProductFromForm(
    form
  ) {

    if (
      addToCartBusy
    ) {

      return;

    }


    if (!form) {
      return;
    }


    var formData =
      new FormData(
        form
      );


    var id =
      formData.get(
        'id'
      );


    if (!id) {
      return;
    }


    addToCartBusy =
      true;


    var submitButton =
      form.querySelector(
        '[type="submit"]'
      );


    var originalButtonText =
      submitButton
        ? submitButton.innerHTML
        : '';


    if (
      submitButton
    ) {

      submitButton.disabled =
        true;


      submitButton.setAttribute(
        'aria-busy',
        'true'
      );

    }


    fetch(
      window.Shopify.routes.root +
      'cart/add.js',
      {
        method: 'POST',

        headers: {
          'Accept':
            'application/json'
        },

        body:
          formData
      }
    )
      .then(
        function (response) {

          if (!response.ok) {

            return response.json()
              .then(
                function (data) {

                  throw new Error(
                    data.description ||
                    data.message ||
                    'Product toevoegen mislukt'
                  );

                }
              );

          }


          return response.json();

        }
      )
      .then(
        function () {

          return fetch(
            window.Shopify.routes.root +
            'cart.js',
            {
              method: 'GET',

              headers: {
                'Accept':
                  'application/json'
              }
            }
          );

        }
      )
      .then(
        function (response) {

          if (!response.ok) {

            throw new Error(
              'Winkelwagen ophalen mislukt'
            );

          }


          return response.json();

        }
      )
      .then(
        function (cart) {

          rebuildDrawer(
            cart
          );


          updateHeader(
            cart
          );


          updateShipping(
            cart
          );


          openDrawer();


          document.dispatchEvent(
            new CustomEvent(
              'slaapgemak:cart-updated',
              {
                detail: {
                  cart:
                    cart
                }
              }
            )
          );

        }
      )
      .catch(
        function (error) {

          console.error(
            'Slaapgemak product toevoegen:',
            error
          );


          try {

            if (form) {

              form.submit();

            }

          } catch (
            fallbackError
          ) {

            console.error(
              'Slaapgemak fallback:',
              fallbackError
            );

          }

        }
      )
      .finally(
        function () {

          if (
            submitButton
          ) {

            submitButton.disabled =
              false;


            submitButton.removeAttribute(
              'aria-busy'
            );


            if (
              originalButtonText
            ) {

              submitButton.innerHTML =
                originalButtonText;

            }

          }


          addToCartBusy =
            false;

        }
      );
  }


  /* =======================================================
     PRODUCT FORM INTERCEPTOR
     ======================================================= */

  document.addEventListener(
    'submit',
    function (event) {

      var form =
        event.target;


      if (!form) {
        return;
      }


      var productId =
        form.querySelector(
          'input[name="id"]'
        );


      if (!productId) {
        return;
      }


      var action =
        form.getAttribute(
          'action'
        ) || '';


      var isProductForm =

        action.indexOf(
          '/cart/add'
        ) !== -1

        ||

        form.matches(
          'form[action*="/cart/add"]'
        )

        ||

        form.closest(
          'product-form'
        ) !== null;


      if (!isProductForm) {
        return;
      }


      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      addProductFromForm(
        form
      );

    },
    true
  );


  /* =======================================================
     CLICK HANDLER
     ======================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var target =
        event.target;


      if (
        !target ||
        !target.closest
      ) {

        return;

      }


      var upsellButton =
        target.closest(
          '[data-sg-upsell-add]'
        );


      if (
        upsellButton
      ) {

        event.preventDefault();
        event.stopPropagation();


        addUpsellProduct(
          upsellButton
        );


        return;

      }


      var submitButton =
        target.closest(
          'button[type="submit"], input[type="submit"]'
        );


      if (
        submitButton
      ) {

        var form =
          submitButton.form ||
          submitButton.closest(
            'form'
          );


        if (
          form
        ) {

          var productId =
            form.querySelector(
              'input[name="id"]'
            );


          var action =
            form.getAttribute(
              'action'
            ) || '';


          var isProductForm =

            productId &&
            (
              action.indexOf(
                '/cart/add'
              ) !== -1

              ||

              form.matches(
                'form[action*="/cart/add"]'
              )

              ||

              form.closest(
                'product-form'
              ) !== null
            );


          if (
            isProductForm
          ) {

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();


            addProductFromForm(
              form
            );


            return;

          }

        }

      }


      var openButton =
        target.closest(
          '[data-slaapgemak-cart-open]'
        );


      if (
        openButton
      ) {

        event.preventDefault();
        event.stopPropagation();


        openDrawer();


        return;

      }


      var closeButton =
        target.closest(
          '[data-slaapgemak-cart-close]'
        );


      if (
        closeButton
      ) {

        event.preventDefault();


        closeDrawer();


        return;

      }


      var increment =
        target.closest(
          '[data-quantity-increment]'
        );


      if (
        increment
      ) {

        event.preventDefault();


        var lineUp =
          parseInt(
            increment.getAttribute(
              'data-line'
            ),
            10
          );


        if (!lineUp) {
          return;
        }


        updateCart(
          lineUp,
          getQuantity(
            lineUp
          ) + 1
        );


        return;

      }


      var decrement =
        target.closest(
          '[data-quantity-decrement]'
        );


      if (
        decrement
      ) {

        event.preventDefault();


        var lineDown =
          parseInt(
            decrement.getAttribute(
              'data-line'
            ),
            10
          );


        if (!lineDown) {
          return;
        }


        updateCart(
          lineDown,
          Math.max(
            0,
            getQuantity(
              lineDown
            ) - 1
          )
        );


        return;

      }


      var remove =
        target.closest(
          '[data-item-remove]'
        );


      if (
        remove
      ) {

        event.preventDefault();


        var lineRemove =
          parseInt(
            remove.getAttribute(
              'data-line'
            ),
            10
          );


        if (!lineRemove) {
          return;
        }


        updateCart(
          lineRemove,
          0
        );

      }

    },
    true
  );


  /* =======================================================
     OVERLAY
     ======================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var target =
        event.target;


      if (
        !target ||
        !target.closest
      ) {

        return;

      }


      var overlay =
        target.closest(
          '[data-slaapgemak-cart-overlay]'
        );


      if (
        overlay
      ) {

        closeDrawer();

      }

    }
  );


  /* =======================================================
     ESCAPE
     ======================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape'
      ) {

        closeDrawer();

      }

    }
  );


  /* =======================================================
     PUBLIC API
     ======================================================= */

  window.slaapgemakCartDrawer = {

    open:
      openDrawer,

    close:
      closeDrawer,

    update:
      updateCart,

    addProduct:
      addProductFromForm,

    refresh:
      function () {

        fetch(
          window.Shopify.routes.root +
          'cart.js'
        )
          .then(
            function (response) {
              return response.json();
            }
          )
          .then(
            function (cart) {

              rebuildDrawer(
                cart
              );


              updateHeader(
                cart
              );


              updateShipping(
                cart
              );


              updateDisplayedDiscountTotal();

            }
          );

      }

  };

})();